// Login with email

export const LOGIN_INITIATE = 'LOGIN_INITIATE';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

// Request OTP
export const REQUEST_OTP = 'REQUEST_OTP';
export const REQUEST_OTP_SUCCESS = 'REQUEST_OTP_SUCCESS';
export const REQUEST_OTP_FAIL = 'REQUEST_OTP_FAIL';

// Verify OTP
export const VERIFY_OTP = 'VERIFY_OTP';
export const VERIFY_OTP_SUCCESS = 'VERIFY_OTP_SUCCESS';
export const VERIFY_OTP_FAIL = 'VERIFY_OTP_FAIL';

// Logout
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

// Contact Us
export const SUBMIT_CONTACT_US_FORM = 'SUBMIT_CONTACT_US_FORM';
export const SUBMIT_CONTACT_US_FORM_SUCCESS = 'SUBMIT_CONTACT_US_FORM_SUCCESS';
export const SUBMIT_CONTACT_US_FORM_FAILED = 'SUBMIT_CONTACT_US_FORM_FAILED';

// Market Data
export const MARKET_LOGIN_REQUEST = 'MARKET_LOGIN_REQUEST';
export const MARKET_LOGIN_SUCCESS = 'MARKET_LOGIN_SUCCESS';
export const MARKET_LOGIN_FAILURE = 'MARKET_LOGIN_FAILURE';

// Verify Email
export const VERIFY_EMAIL_REQUEST = 'VERIFY_EMAIL_REQUEST';
export const VERIFY_EMAIL_SUCCESS = 'VERIFY_EMAIL_SUCCESS';
export const VERIFY_EMAIL_FAILURE = 'VERIFY_EMAIL_FAILURE ';

// Create Password
export const CREATE_PASSWORD_REQUEST = 'CREATE_PASSWORD_REQUEST';
export const CREATE_PASSWORD_SUCCESS = 'CREATE_PASSWORD_SUCCESS';
export const CREATE_PASSWORD_FAILURE = 'CREATE_PASSWORD_FAILURE ';

export const BACK_TO_LOGIN = 'BACK_TO_LOGIN ';

// Forgot Password
export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE ';

// Reset Password
export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE ';

// Verify Link
export const VERIFY_LINK_REQUEST = 'VERIFY_LINK_REQUEST';
export const VERIFY_LINK_SUCCESS = 'VERIFY_LINK_SUCCESS';
